import React, { useState, useEffect } from "react";
import Alert from "../../components/Alert";
import Breadcrumb from "../../parts/Breadcrumb";
import { Link } from "react-router-dom";
import { pluck, reject, contains } from "underscore";
import ListSection from "../../components/ListSection";
// import DeleteModel from "../../components/DeleteModel";
import labels from "../../constants/Trips";
import configuration from "../../config";
import { toast } from "react-toastify";
import Loader from "../../components/Loader/Loader";
import { reactLocalStorage } from "reactjs-localstorage";
let userType = reactLocalStorage.get("user_type");
// List all users
function View({ location }) {
  const columns = [
    {
      title: "ID",
      field: "trip_id",
      render: (rowData) => (
        <Link
          className="text-indigo-600 hover:text-indigo-900"
          to={`/tripsdetail/${rowData.trip_id}`}
        >
          {rowData.trip_id}
        </Link>
      ),
    },
    { title: "Passenger", field: "passenger_info" },
    { title: "Driver", field: "driver_info" },
    { title: "Vehicle", field: "vehicle_ride_option_info" },
    { title: "Service", field: "service_info" },
    { title: "OTP", field: "otp" },
    { title: "Sub Total", field: "subtotal" },
    { title: "Total", field: "total" },
    // 👇 Insert Commission column conditionally here
    ...(userType === "partner"
      ? [
          {
            title: "Commission",
            field: "requested_commission",
            render: (rowData) =>
              rowData?.requested_commission != null
                ? rowData.requested_commission
                : 0,
          },
        ]
      : []),
    ...(userType === "company"
      ? [
          {
            title: "Admin Commission",
            field: "requested_commission",
            render: (rowData) =>
              rowData?.requested_commission != null
                ? rowData.requested_commission
                : 0,
          },
        ]
      : []),
    { title: "Book Date", field: "booking_date" },
    {
      title: "Status",
      field: "status",
      render: (rowData) => {
        return <span className="capitalize">{rowData.status}</span>;
      },
    },
    {
      title: "Action",
      field: "action",
      render: (rowData) => (
        <Link
          to={`/invoice/${rowData.trip_id}`}
          className="inline-flex items-center px-3 py-0.5 rounded-md text-basefont-medium bg-indigo-600 text-white capitalize"
        >
          Invoice
        </Link>
      ),
    },
  ];
  const [data, setData] = useState([]);
  const [csvData, setcsvData] = useState([]);
  const [isLoader, setIsLoader] = useState(false);

  const btnGroups = [
    {
      id: 2,
      title: "Export CSV",
      type: "exportCSV",
      path: "/user",
      fileName: "Trips",
    },
  ];
  const [show, setShow] = useState(false);
  // const [showModal, setShowModal] = useState(false);
  const fieldArr = [
    {
      id: 3,
      title: "From  Date",
      name: "from_date",
      type: "DatePicker",
      disablePast: false,
    },
    {
      id: 4,
      title: "To Date",
      name: "to_date",
      type: "DatePicker",
      disablePast: false,
    },
  ];
  const [fieldsFilter, setFieldsFilter] = useState({
    from_date: null,
    to_date: null,
  });
  const [errorsFilter, setErrorsFilter] = useState({
    from_date: "",
    to_date: "",
  });

  const [ids, setIds] = useState([]);

  useEffect(() => {
    getDatas({});
  }, []);

  function getDatas(filterData) {
    setIsLoader(true);
    configuration
      .getAPI({
        url: "trip/list",
        params: { filterData: JSON.stringify(filterData) },
      })
      .then((data) => {
        setIsLoader(false);
        if (data.status === 200) {
          setData(data.payload);
          const formatted = data.payload.map((item) => ({
            ID: item.trip_id,
            Passenger: item.passenger_info,
            Driver: item.driver_info,
            Vehicle: item.vehicle_ride_option_info,
            Service: item.service_info,
            "Sub Total": item.subtotal,
            Total: item.total,
            "Book Date": item.booking_date,
            Status: item.status,
          }));
          setcsvData(formatted);
        }
      })
      .catch((error) => {
        setIsLoader(false);
        return toast.error(error.message);
      });
  }
  const onSelectionChange = (e) => {
    let idArr = pluck(e, "user_id");
    setIds(idArr);
  };

  function handleApplyFilter() {
    if (handleFilterValidation()) {
      getDatas(fieldsFilter);
      // getItemAvailability(fieldsFilter);
    }
  }
  function handleClearFilter() {
    setFieldsFilter({ status: [], from_date: null, to_date: null });
    setErrorsFilter({});
    getDatas({});
  }

  function handleChangeFilter(field, e) {
    if (field === "status") {
      console.log(field);
      console.log(e.target.value);
      let sessionData = fieldsFilter.status ? fieldsFilter.status : [];
      if (!contains(sessionData, e.target.value)) {
        sessionData.push(e.target.value);
      } else {
        sessionData = reject(sessionData, function (num) {
          return num === e.target.value;
        });
      }
      console.log(sessionData);
      setFieldsFilter({ ...fieldsFilter, [field]: sessionData });
      if (sessionData && sessionData.length <= 0) {
        delete fieldsFilter.status;
        getDatas({ fieldsFilter });
      } else {
        getDatas({ ...fieldsFilter, [field]: sessionData });
      }
    } else {
      setFieldsFilter({ ...fieldsFilter, [field]: e });
    }
  }
  function handleFilterValidation() {
    let flag = true;
    let error = {};
    if (fieldsFilter.to_date && !fieldsFilter.from_date) {
      error["from_date"] = "Please select from date";
      flag = false;
    }
    if (!fieldsFilter.to_date) {
      error["from_date"] = "Please select to date";
      flag = false;
    }
    if (!fieldsFilter.from_date) {
      error["from_date"] = "Please select from date";
      flag = false;
    }
    if (fieldsFilter.from_date && !fieldsFilter.to_date) {
      error["to_date"] = "Please select to date";
      flag = false;
    }
    if (fieldsFilter.from_date && fieldsFilter.to_date) {
      if (fieldsFilter.to_date < fieldsFilter.from_date) {
        flag = false;
        error["to_date"] = "Please select end date greater than to start date.";
      }
    }
    if (fieldsFilter.status && fieldsFilter.status.length <= 0) {
      delete fieldsFilter.status;
      setFieldsFilter(fieldsFilter);
    }
    setErrorsFilter({ ...error });
    return flag;
  }

  return (
    <>
      <Breadcrumb module={labels.Trips} />
      <Loader isOpen={isLoader} />
      <Alert
        show={show}
        setShow={setShow}
        bgColorClass="green"
        caption="Success"
        message="Record added successfully"
      />
      <ListSection
        captionTitle="View Trips"
        columns={columns}
        data={data}
        btnGroups={btnGroups}
        filters={true}
        fieldArr={fieldArr}
        disabledCheckbox={true}
        onSelectionChange={onSelectionChange}
        handleApplyFilter={handleApplyFilter}
        handleClearFilter={handleClearFilter}
        handleChangeFilter={handleChangeFilter}
        fieldsFilter={fieldsFilter}
        errorsFilter={errorsFilter}
        csvData={csvData}
        csvName={"Trips"}
      />
    </>
  );
}

export default View;
